'use client'

import CategoryNavigationItemList from '@productsite-beta/src/components/filters/category-navigation-item-list'
import { NavigationItemFragment } from '@productsite-beta/src/graphql/generated/graphql-types'
import { SiblingEventMutation } from '@dustin-web/microsite-components/src/hooks/use-sibling-event'
import { useI18n } from '@dustin-web/microsite-components/src/i18n'
import { AccessoryGroups } from './product-accessories'

type CategoryBoxProps = {
  groups: AccessoryGroups
  moreGroups: NavigationItemFragment[]
  scrollToSiblingMutation: SiblingEventMutation<string>
  activeMenuItem: string | null | undefined
}

export const AccessoryCategoryMenu = ({
  groups,
  moreGroups,
  scrollToSiblingMutation,
  activeMenuItem,
}: CategoryBoxProps) => {
  const { translate } = useI18n()

  const categoryNavigation = Object.keys(groups).map(category => {
    const mapped: NavigationItemFragment = {
      categoryId: category,
      category: {
        name: category,
        pathSlug: groups[category][0].category?.pathSlug || '',
        categoryImageFileName: '',
      },
      hits: groups[category].length,
      selected: false,
    }
    return mapped
  })

  return (
    <>
      <h3 className="h4 u-mb-16">{translate('AccessoryCategories')}</h3>
      <CategoryNavigationItemList
        navigationItems={[...moreGroups, ...categoryNavigation]}
        showAll={true}
        scrollTo={true}
        scrollToSiblingMutation={scrollToSiblingMutation}
        accessoryCategories
        activeAccessoryMenuItem={activeMenuItem}
      />
    </>
  )
}
